import { useEffect } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';

type UseGTM = {
  action: string;
  event_category: string;
  event_label: string;
};

type UserInfoType = Record<string, string | number> | null;

export const useGTM = ({
  action,
  event_category,
  event_label,
  fireOnMount,
}: UseGTM & { fireOnMount?: boolean }): {
  fireEvent: (additionalInfo?: Record<string, string | number>) => void;
} => {
  const generateUserInfo = async (): Promise<UserInfoType> => {
    const user = localStorage.getItem('user');
    let userInfo: UserInfoType = {};

    if (!user) {
      return userInfo;
    }

    const userObject = JSON.parse(user);
    let user_name = userObject.personalInfo?.firstname || '';

    if (userObject.personalInfo?.lastname) {
      if (user_name) {
        user_name += ' ' + userObject.personalInfo.lastname;
      } else {
        user_name = userObject.personalInfo.lastname;
      }
    }

    userInfo = {
      user_id: userObject.id,
      user_name: user_name,
      user_email: userObject.personalInfo?.email,
      user_phone: userObject.personalInfo?.phoneNumber,
      user_country: userObject.personalInfo?.country,
      user_city: userObject.personalInfo?.city,
      user_national_id: userObject.personalInfo?.nationalId,
      src: userObject.personalInfo?.referralId,
      device: 'other',
    };

    if (isMobile) {
      userInfo.device = 'mobile';
    }
    if (isDesktop) {
      userInfo.device = 'desktop';
    }

    return userInfo;
  };

  const fireEvent = async (additionalInfo?: Record<string, string | number>): Promise<void> => {
    const userInfo = await generateUserInfo();

    const utm = {
      utm_source: sessionStorage.getItem('utm_source') || '',
      utm_campaign: sessionStorage.getItem('utm_campaign') || '',
      utm_medium: sessionStorage.getItem('utm_medium') || '',
      utm_content: sessionStorage.getItem('utm_content') || '',
    };

    const eventPayload = {
      event: action,
      event_category,
      event_label,
      ...additionalInfo,
      ...utm,
      ...userInfo,
    };
    // Uncomment to add delay for analytics scripts loading
    // Google tag manager event tracking
    // if (!window.dataLayer) {
    //   if (!window.pendingDataLayerEvents) {
    //     window.pendingDataLayerEvents = [];
    //   }
    //   window.pendingDataLayerEvents.push(eventObject);
    //   return;
    // }

    console.log(`[useGTM] Event triggered: ${action}`, eventPayload);
    window.dataLayer?.push(eventPayload);
  };

  useEffect(() => {
    fireOnMount && fireEvent();
  }, []);

  return { fireEvent };
};
